import type { ListingCardPriceListing } from '@ha/core/Listing/getListingCardPriceInformation';

import { ListingCardModel } from 'ha/models/Listing/types';
import {
  centsRecordToMajor,
  centsToMajor,
} from 'ha/models/Listing/utilities/centsToMajor';

/**
 * The card price rules take major units, except `price`, which stays in
 * cents. The model's minimum is the price when a listing has none, so a strict
 * listing without one is priced at its price. Only search index cards show a
 * range; API cards show one amount.
 */
export function toListingCardPriceListing(
  listing: ListingCardModel,
): ListingCardPriceListing {
  const { pricing } = listing;

  return {
    recordType: listing.identifiers.recordType,
    propertyMinPriceOverall: centsToMajor(
      pricing.propertyMinPricesCents.overall,
    ),
    propertyMinPriceSharedRooms: centsToMajor(
      pricing.propertyMinPricesCents.sharedRooms,
    ),
    propertyMinPricePrivateRooms: centsToMajor(
      pricing.propertyMinPricesCents.privateRooms,
    ),
    propertyMinPriceStudios: centsToMajor(
      pricing.propertyMinPricesCents.studios,
    ),
    propertyMinPriceApartments: centsToMajor(
      pricing.propertyMinPricesCents.apartments,
    ),
    rentalPeriodType: listing.availability.rentalPeriodType,
    minPrice: centsToMajor(pricing.minPriceCents),
    maxPrice:
      listing.source === 'algolia'
        ? centsToMajor(pricing.maxPriceCents)
        : undefined,
    price: pricing.priceCents,
    priceType: pricing.priceType,
    pricingValues: {
      flat: centsToMajor(pricing.valuesCents.flat),
      monthly: pricing.valuesCents.monthly
        ? centsRecordToMajor(pricing.valuesCents.monthly)
        : null,
      ...(pricing.valuesCents.precise
        ? { precise: centsRecordToMajor(pricing.valuesCents.precise) }
        : {}),
    },
  };
}
